<div class="cg-margin-bottom-sm" data-test="cg-user-tin-lob-header">
  <strong>Identified</strong>
</div>
<div class="cg-margin-bottom-lg" data-test="cg-assigned-tin">
  <ng-container
    *ngTemplateOutlet="lobPref; context: { lob: user?.lob }"
  ></ng-container>
</div>
<div class="cg-margin-bottom-sm" data-test="cg-user-tin-lob-header">
  <strong>Preferred</strong>
</div>
<div class="cg-margin-bottom-lg" data-test="cg-assigned-tin">
  <ng-container
    *ngTemplateOutlet="lobPref; context: { lob: user?.lobPref }"
  ></ng-container>
</div>

<div
  *ngIf="user?.lob === LOB_MEDBH && canEdit && hasDualTin"
  class="cg-margin-bottom-sm"
  data-test="cg-edit-user-pref-lob-header"
>
  <button
    cignaButton="link"
    style="padding: 0; text-align: left"
    [disabled]="isImpersonator"
    data-test="edit-user-lob-pref"
    (click)="openPreferredLOBModel()"
  >
    Edit Preferred Line of Business
  </button>
</div>

<ng-template #lobPref let-lob="lob">
  {{
    lob === LOB_MEDBH || lob === 'BOTH'
      ? 'Medical/Behavioral'
      : lob === LOB_MEDICAL || lob === 'CHCP'
      ? 'Medical'
      : lob === LOB_BEHAVIORAL || lob === 'EBH'
      ? 'Behavioral'
      : '--'
  }}
</ng-template>
